import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import type { FieldValidation } from '@rjsf/utils';
import { ZipUploadPicker } from './ZipUploadPicker';

export const ZipUploadPickerFieldExtension = FormFieldBlueprint.make({
  name: 'zip-upload-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'ZipUploadPicker',
        component: ZipUploadPicker as any,
        validation: (value: string | undefined, validation: FieldValidation) => {
          if (!value?.trim()) {
            validation.addError('Envie um arquivo .zip');
          }
        },
        schema: makeFieldSchema({
          output: z => z.string(),
        }),
      }),
  },
});
